import React from 'react';
import { MoreHorizontal, Clock, TrendingUp, Eye, MousePointer } from 'lucide-react';
import { motion } from 'framer-motion';
interface CampaignCardProps {
  title: string;
  description: string;
  lastEdited: string;
  status: 'activa' | 'pausada' | 'borrador';
  platform: 'facebook' | 'google' | 'whatsapp' | 'linkedin' | 'heygen' | 'higgsfield';
  metrics?: {
    impressions?: string;
    clicks?: string;
    ctr?: string;
  };
}
const platformIcons: Record<string, React.ReactNode> = {
  facebook: <svg className="w-5 h-5" viewBox="0 0 24 24" fill="#1877F2" data-id="element-38">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-39" />
    </svg>,
  google: <svg className="w-5 h-5" viewBox="0 0 24 24" data-id="element-40">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-41" />
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-42" />
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-43" />
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-44" />
    </svg>,
  whatsapp: <svg className="w-5 h-5" viewBox="0 0 24 24" fill="#25D366" data-id="element-45">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-46" />
    </svg>,
  linkedin: <svg className="w-5 h-5" viewBox="0 0 24 24" fill="#0A66C2" data-id="element-47">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-48" />
    </svg>,
  heygen: <div className="w-5 h-5 rounded bg-gradient-to-br from-purple-500 to-blue-500 flex items-center justify-center text-white text-[10px] font-bold" data-id="element-49">
      HG
    </div>,
  higgsfield: <div className="w-5 h-5 rounded bg-gradient-to-br from-pink-500 to-orange-500 flex items-center justify-center text-white text-[10px] font-bold" data-id="element-50">
      HF
    </div>
};
const statusConfig = {
  activa: {
    bg: 'bg-green-100',
    text: 'text-green-700',
    border: 'border-green-200',
    label: 'Activa'
  },
  pausada: {
    bg: 'bg-yellow-100',
    text: 'text-yellow-700',
    border: 'border-yellow-200',
    label: 'Pausada'
  },
  borrador: {
    bg: 'bg-gray-100',
    text: 'text-gray-700',
    border: 'border-gray-200',
    label: 'Borrador'
  }
};
const platformGradients: Record<string, string> = {
  facebook: 'from-blue-500/20 to-blue-600/20',
  google: 'from-red-500/20 via-yellow-500/20 to-green-500/20',
  whatsapp: 'from-green-500/20 to-green-600/20',
  linkedin: 'from-blue-600/20 to-blue-700/20',
  heygen: 'from-purple-500/20 to-blue-500/20',
  higgsfield: 'from-pink-500/20 to-orange-500/20'
};
export function CampaignCard({
  title,
  description,
  lastEdited,
  status,
  platform,
  metrics
}: CampaignCardProps) {
  const statusStyle = statusConfig[status];
  return <motion.div whileHover={{
    y: -4
  }} className="group bg-white rounded-2xl border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer" data-id="element-51">
      {/* Header with gradient */}
      <div className={`h-32 bg-gradient-to-br ${platformGradients[platform]} relative overflow-hidden`} data-id="element-52">
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-53">
          <div className="w-16 h-16 rounded-2xl bg-white/80 backdrop-blur-sm flex items-center justify-center shadow-lg" data-id="element-54">
            {platformIcons[platform]}
          </div>
        </div>
        <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-55">
          <button className="p-1.5 bg-white/90 backdrop-blur-sm rounded-lg hover:bg-white shadow-sm" data-id="element-56">
            <MoreHorizontal className="w-4 h-4 text-gray-600" data-id="element-57" />
          </button>
        </div>
        <div className={`absolute top-3 left-3 px-2 py-1 rounded-md text-[10px] font-bold uppercase tracking-wider border ${statusStyle.bg} ${statusStyle.text} ${statusStyle.border}`} data-id="element-58">
          {statusStyle.label}
        </div>
      </div>

      {/* Content */}
      <div className="p-5" data-id="element-59">
        <h3 className="font-bold text-gray-900 mb-1 group-hover:text-orange-600 transition-colors" data-id="element-60">
          {title}
        </h3>
        <p className="text-sm text-gray-500 mb-4 line-clamp-2" data-id="element-61">{description}</p>

        {/* Metrics */}
        {metrics && <div className="flex items-center gap-4 mb-4 text-xs" data-id="element-62">
            {metrics.impressions && <div className="flex items-center gap-1 text-gray-500" data-id="element-63">
                <Eye className="w-3.5 h-3.5" data-id="element-64" />
                <span data-id="element-65">{metrics.impressions}</span>
              </div>}
            {metrics.clicks && <div className="flex items-center gap-1 text-gray-500" data-id="element-66">
                <MousePointer className="w-3.5 h-3.5" data-id="element-67" />
                <span data-id="element-68">{metrics.clicks}</span>
              </div>}
            {metrics.ctr && <div className="flex items-center gap-1 text-green-600" data-id="element-69">
                <TrendingUp className="w-3.5 h-3.5" data-id="element-70" />
                <span data-id="element-71">{metrics.ctr}</span>
              </div>}
          </div>}

        <div className="flex items-center text-xs text-gray-400 gap-1" data-id="element-72">
          <Clock className="w-3.5 h-3.5" data-id="element-73" />
          <span data-id="element-74">Editado {lastEdited}</span>
        </div>
      </div>
    </motion.div>;
}